import React from 'react';
import lockscreenDesktop from '../assets/lockscreen/lockscreen-desktop.webp';
import lockscreenTablet from '../assets/lockscreen/lockscreen-tablet.webp';
import lockscreenMobile from '../assets/lockscreen/lockscreen-mobile.webp';

export const LockScreen: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
      background: 'var(--fs-bg)',
    }}
  >
    {/* Background image — responsive */}
    <picture>
      <source media="(min-width: 1024px)" srcSet={lockscreenDesktop} />
      <source media="(min-width: 768px)" srcSet={lockscreenTablet} />
      <img
        src={lockscreenMobile}
        alt=""
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </picture>

    {/* Overlay */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(10,10,10,0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 20,
          textAlign: 'center',
          padding: '0 24px',
        }}
      >
        {/* Lock icon */}
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'rgba(0,212,255,0.08)',
            border: '1px solid rgba(0,212,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--fs-cyan)',
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        {/* Text */}
        <h1
          style={{
            fontFamily: 'var(--fs-font-headline)',
            fontWeight: 700,
            fontSize: 24,
            color: 'var(--fs-text)',
            letterSpacing: 'var(--fs-tracking-tight)',
            margin: 0,
          }}
        >
          Sign in to use
        </h1>
        <p
          style={{
            fontFamily: 'var(--fs-font-body)',
            fontSize: 14,
            color: 'var(--fs-text-muted)',
            margin: 0,
            maxWidth: 320,
            lineHeight: 1.5,
          }}
        >
          MockUp Gen is available on FORMA Studio
        </p>

        {/* CTA */}
        <a
          href="https://forma.frankriccidesign.com"
          className="fs-btn-primary"
          style={{
            padding: '12px 32px',
            fontSize: 14,
            textDecoration: 'none',
            marginTop: 8,
          }}
        >
          Go to FORMA Studio
        </a>
      </div>
    </div>
  </div>
);
